document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.ol-size-guide').forEach(function (guide) {
    var tabs = Array.from(guide.querySelectorAll('[data-guide-tab]'));
    var panels = Array.from(guide.querySelectorAll('[data-guide-panel]'));

    function activate(tab) {
      var target = tab.getAttribute('data-guide-tab');
      tabs.forEach(function (item) {
        var active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        item.setAttribute('tabindex', active ? '0' : '-1');
      });
      panels.forEach(function (panel) {
        var active = panel.getAttribute('data-guide-panel') === target;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { activate(tab); });
      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        var direction = event.key === 'ArrowRight' ? 1 : -1;
        var next = tabs[(index + direction + tabs.length) % tabs.length];
        activate(next);
        next.focus();
      });
    });
  });
});
